/**
 * Format FerBoost pool lockPeriod
 * @param lockPeriod Lock period in minutes
 * @returns Formatted lock period
 */

const formatLockPeriod = (lockPeriod: number): string => {
  let value = lockPeriod

  const units = {
    Year: 30 * 24 * 60 * 60 * 12,
    Month: 30 * 24 * 60 * 60,
    Day: 24 * 60 * 60,
    Hour: 60 * 60,
    Minute: 60,
    Second: 1,
  }

  const result: string[] = []

  Object.keys(units).forEach((key) => {
    const typedKey = key as keyof typeof units
    const p = Math.floor(value / units[typedKey])

    const isUseRoughEstimation =
      result.length === 1 && result[0].includes(Object.keys(units)[0])

    if (p === 1) result.push(isUseRoughEstimation ? "" : `${p} ${key}`)
    if (p >= 2) result.push(isUseRoughEstimation ? "" : `${p} ${key}s`)
    value %= units[typedKey]
  })

  return result.join(" ")
}

export default formatLockPeriod
